<template>
  <div class="content">
    <!-- <el-row class="content-head">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>考勤管理</el-breadcrumb-item>
            <el-breadcrumb-item>打卡记录</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>-->
    <!-- 主体 -->
    <el-container class="content-container">
      <el-main style="height: 100%;padding:0px !important;  position: relative;width: 100%;">
        <el-card style="height:100% !important;" class="aside">
          <!-- 上 -->
          <div class="search-section">
            <div style="display:flex;align-items:center">
              <div style="display:flex;align-items:center;margin-right:20px">
                <span style="margin-right:10px">进出类型:</span>
                <el-button-group style="text-align:right;display:block">
                  <el-button plain @click="doFilter1()"   :class="{cur : search.flag===''}">全部</el-button>
                  <el-button plain @click="doFilter1(0)" :class="{cur : search.flag===0}">注册车辆</el-button>
                  <el-button plain @click="doFilter1(1)" :class="{cur : search.flag===1}">临时车辆</el-button>
                </el-button-group>
              </div>
              <div style="display:flex;align-items:center">
                <el-input v-model="search.carNumber" placeholder="请输入车牌号" clearable>
                  <el-button slot="append" icon="el-icon-search" @click="doFilter"></el-button>
                </el-input>
              </div>
            </div>
            <el-date-picker
              v-model="search.time"
              format="yyyy-MM--dd"
              @change="doFilter"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            ></el-date-picker>
            <!-- <el-button
              type="primary"
              plain
              style="display:flex;align-items:center"
              @click="exportInfo()"
            >导出</el-button> -->
          </div>
          <!-- 表格 -->
          <div class="build-table">
            <el-table
              stripe
              :data="listData"
              height="100%"
              style="width: 100%;"
              :header-cell-style="{background:'#F5F7F9',color:'#909399'}"
            >
              <template slot="empty">
                <p>{{dataText}}</p>
              </template>
              <el-table-column label="序号" width="100" center>
                <template slot-scope="scope">
                  <a style="padding-left:1vw;">{{ scope.row.index}}</a>
                </template>
              </el-table-column>
              <el-table-column label="姓名">
                <template slot-scope="scope">
                  <span>{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column label="车牌号">
                <template slot-scope="scope"  >
                  <span @click="lookPhoto(scope.row)">{{ scope.row.carNumber }}</span>
                  <el-image 
                    style="width: 100px; height: 100px;display:none"
                    :src="scope.row.photo" 
                    :preview-src-list="scope.row.srcList">
                  </el-image>
                </template>
              </el-table-column>
              <el-table-column label="手机号">
                <template slot-scope="scope">
                  <span>{{ scope.row.phone }}</span>
                </template>
              </el-table-column>
              <!-- maxDate --> 
              <el-table-column label="出入次">
                <template slot-scope="scope">
                  <span>{{scope.row.inOutCount}}</span>
                </template>
              </el-table-column>
              <el-table-column label="时长">
                <template slot-scope="scope">
                  <span>{{scope.row.parkingTime}}/h</span>
                </template>
              </el-table-column>
              <el-table-column label="最近一次进时间">
                <template slot-scope="scope">
                  <span @click="lookPhoto(scope.row)">{{scope.row.enterDate}}</span>
                  <!-- <el-image 
                    style="width: 100px; height: 100px;"
                    :src="scope.row.enterPhoto" 
                    :preview-src-list="scope.row.srcList">
                  </el-image> -->
                </template>
              </el-table-column>
              <el-table-column label="最近一次出时间">
                <template slot-scope="scope">
                  <span @click="lookPhotoout(scope.row)">{{scope.row.outDate}}</span>
                  <!-- <span>{{scope.row.time}}</span>
                  <span v-if="scope.row.direction==1" style="color:#64FB6E">进</span>
                  <span v-if="scope.row.direction==2" style="color:#64FB6E">出</span> -->
                </template>
              </el-table-column>
              <!-- <el-table-column label="操作">
                <template slot-scope="scope">
                  <span class="color1 hand" @click="edit( scope.row)">查看</span>
                </template>
              </el-table-column> -->
            </el-table>
          </div>
          <div class="el-end">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[3, 5, 10, 20]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
            ></el-pagination>
          </div>
        </el-card>
        <el-dialog
          title="车辆图片"
          :visible.sync="dialogVisible"
          width="70%"
          :before-close="handleClose">
             <img style="width:100%" :src="itemPhoto" alt="">
          <!-- <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
          </span> -->
        </el-dialog>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import myHttp from '../../untils/port.js'
import util from '../../untils/util.js'
import base from '../../untils/base'
export default {
  data() {
    return {
      search: {
        //查询
        carNumber: '',
        projectId: '',
        flag:'',
        time: '',
        // util.myTime.getCurTime()
      },
      listData: [], //表格数据
      dataText: '数据加载中...',
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      dialogVisible:false,
      itemPhoto:''
    }
  },
  created() {
    if (util.session.get('roleId') == '4') {
      this.search.projectId = util.session.get('groupId')
    } else {
      this.search.projectId = util.session.get('proId')
    }
  },
  mounted() {
    //this.search.projectId = util.session.get('groupId')
    // if (this.search.projectId == '') {
    //   this.$store.commit('setGroupId')
    //   this.search.projectId = this.$store.state.groupId
    // }
    // console.log(this.search.projectId)
    if (util.session.get('roleId') == '4') {
      this.search.projectId = util.session.get('groupId')
    } else {
      this.search.projectId = util.session.get('proId')
    }
    this.getDict() //获取考勤
    //this.getData()
  },
  methods: {
    //
    getDict() {
      var that = this
      myHttp
        .getDictByType({
          type: 'attend_type',
        })
        .then(function (resp) {
          if (resp.data.code == '200') {
            that.attendType = resp.data.data.dictList
            that.getData()
          } else {
            that.$message.error(resp.data.msg)
          }
        })
    },
    //获取类型
    filterSatus(str) {
      var list = this.attendType
      var result = ''
      for (var i = 0; i < list.length; i++) {
        if (str == list[i].value) {
          result = list[i].label
        }
      }
      return result
    },
    // 搜索数据
    doFilter() {
      // this.search.startDate = this.date ? this.date[0] : ''
      // this.search.endDate = this.date ? this.date[1] : ''
      this.currentPage = 1
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage()
    },
    //监控当前页码
    currentChangePage(list) {
      this.getData()
    },
    // 获取数据
    getData() {
      var that = this
      this.search.pageNum = this.currentPage
      this.search.pageSize = this.pageSize
      // selectCarInOutInfoPage
      myHttp.selectCarInOutInfoPage(this.search).then(
        function (resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.list || []
            for (var i = 0; i < list.length; i++) {
              list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
              // list[i].photoFile =
              //   list[i].photoFile && list[i].photoFile != ''
              //     ? base.httpCtx + list[i].photoFile
              //     : ''
              list[i].typeName = that.filterSatus(list[i].status)
              list[i].enterPhoto=list[i].enterPhoto && list[i].enterPhoto != ''
                  ? base.httpCtx + list[i].enterPhoto
                  : ''
              list[i]. srcList=list[i].enterPhoto && list[i].enterPhoto != ''
                  ? [list[i].enterPhoto]
                  : ''
              list[i].outPhoto=list[i].outPhoto && list[i].outPhoto != ''
                  ? base.httpCtx + list[i].outPhoto
                  : ''
            console.log(list[i].enterPhoto)
              // list[i].idcardPhoto = list[i].idcardPhoto && list[i].idcardPhoto!=''?base.httpCtx+list[i].idcardPhoto:''
              // list[i].createDate = list[i].createDate && list[i].createDate!=''?list[i].createDate.split(' ')[0]:''
              // list[i].age = util.myTime.getAge(list[i].birthday)
            }
            that.listData = list
            that.totalItems = resp.data.data.total || 0
            //that.getTypeName()
            if (that.listData.length == 0) {
              that.dataText = '暂无数据'
            }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '暂无数据'
          }
        },
        function () {}
      )
    },
    exportWorker() {
      var token = util.session.get('token')
      window.open(
        myHttp.exportAttendList +
          '?projectId=' +
          this.search.projectId +
          '&personName=' +
          this.search.personName +
          '&date=' +
          this.search.date +
          '&accessToken=' +
          token
      )
    },
    // watchInput(e) {
    //   this.search.personName = e
    //   this.getData()
    // }
    personInfo(index, row) {
      this.$router.push({ name: 'workerInfo', params: { id: row.personId } })
    },
    doFilter1(index){
     console.log(index)
     if(index==undefined){
      this.search.flag=''
      this.getData()
     }else{
      this.search.flag=index
      this.getData()
     }

    },
    lookPhoto(row){
      console.log(row)
        this.dialogVisible =true
        this.itemPhoto =row.enterPhoto
    },
    lookPhotoout(row){
       this.dialogVisible =true
        this.itemPhoto =row.outPhoto
    },
    handleClose(){
       this.dialogVisible =false
    }
    //   doFilter2(e){
    //   this.search.carNumber=e
    //   this.getData()
    // }
  },
}
</script>
<style>
@import '../../assets/css/common.css';
</style>
<style scoped>
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
  overflow: auto;
}
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
}
.search-section {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 20px 35px 20px 10px;
  height: 40px;
  justify-content: space-between;
}
.el-end {
  height: 47px;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  text-align: center;
}
.build-table {
  height: calc(100% - 127px);
  width: 98%;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.el-pagination {
  margin: auto;
}
.el-table--fit {
  border-bottom: 1px solid #f5f5f5;
}
.cur{
  background: #ECF5FF !important;
  /* border: 1px solid   #409EFF !important ; */
  color:#409EFF !important  ;
}
</style>